import { render, staticRenderFns } from "./TheDiagnostic.vue?vue&type=template&id=ffec4b54&"
import script from "./TheDiagnostic.vue?vue&type=script&lang=js&"
export * from "./TheDiagnostic.vue?vue&type=script&lang=js&"
import style0 from "./TheDiagnostic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports